export const ADDPRODUCT = 'products/add';
export const INCREASEPRODUCT = 'products/increase';
export const DECREASEPRODUCT = 'products/decrease';
export const INCREASEPRODUCTBYVALUE = 'products/increaseByValue';
